import script from "./StatisticVentesParVendeur.vue?vue&type=script&setup=true&lang=js"
export * from "./StatisticVentesParVendeur.vue?vue&type=script&setup=true&lang=js"

import "./StatisticVentesParVendeur.vue?vue&type=style&index=0&id=6b061604&lang=css"

const __exports__ = script;

export default __exports__